import React, { useEffect, useContext, useState, useRef } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
} from '@material-ui/core';

import SuperAdminContext from "../../../contexts/SuperAdminContext"

import TopBar from "../../../components/ui/Admin/TopBar"
import GroupForm from '../../../components/ui/Admin/Groups/GroupForm'
import UsersResult from '../../../components/ui/Admin/Groups/UsersResult'

import APIS from "../../../utils/APIS"

const Group = () => {
  const navigate = useNavigate()
  const params = useParams();

  const { groupes, updateAdminGroupes } = useContext(SuperAdminContext)

  const [group, setGroup] = useState(null)
  const [hasChanged, setHasChanged] = useState(false)
  const [simulationModal, setSimulationModal] = useState(false)

  const setActGroup = () => {
    var findGroup = groupes?.find((l) => l.id.toString() == params?.id)

    if (findGroup) {
      if (group == null || group.id !== findGroup.id) {
        setGroup(findGroup)
      }
    } else {
      navigate("/admin/groupe")
    }
  }

  useEffect(() => {
    if (params?.id && groupes) {
      setActGroup()
    }
  }, [groupes, group, params])


  const onSubmit = (editedGroup) => {
    APIS.editGroupe(editedGroup).then((result) => {
      updateAdminGroupes()
    })
    setHasChanged(false)
  }


  return (
    <>
      <Helmet>
        <title>Admin Groupes | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:"20px",
            backgroundColor:"background.grey",
          }}
        >
          <TopBar
            withBack="/admin/groupe"
            title="Infos sur le groupe"
          >
            {(group?.archived === "false" && hasChanged !== true && group?.isTheScanGroupe !== 1) &&
              <Button
                variant="contained"
                sx={{ minHeight:"35px !important" }}
                onClick={() => { setSimulationModal(true) }}
              >
                Créer une simulation
              </Button>
            }
            {group?.archived === "true" &&
              <Button
                variant="contained"
                sx={{ minHeight:"35px !important" }}
                disabled={hasChanged}
                onClick={() => {
                  APIS.archiveOrNotGroupe({id : group?.id, archived : "false"}).then((result) => {
                    setGroup({...group, archived:"false"})
                    updateAdminGroupes()
                  })
                }}
              >
                Désarchiver
              </Button>
            }
            {group?.archived === "false" &&
              <Button
                variant="contained"
                sx={{ minHeight:"35px !important" }}
                disabled={hasChanged}
                onClick={() => {
                  APIS.archiveOrNotGroupe({id : group?.id, archived : "true"}).then((result) => {
                    setGroup({...group, archived:"true"})
                    updateAdminGroupes()
                  })
                }}
              >
                Archiver
              </Button>
            }
            <Button
              variant="contained"
              sx={{ minHeight:"35px !important" }}
              disabled={!hasChanged}
              onClick={() => {
                document.getElementById('hidden_form_submit').click()
              }}
            >
              Éditer le groupe
            </Button>
          </TopBar>

          {group !== null && (
            <>
              <GroupForm
                group={group}
                setHasChanged={setHasChanged}
                hasChanged={hasChanged}
                onSubmit={onSubmit}
                simulationModal={simulationModal}
                closeSimulationModal={() => {
                  setSimulationModal(false)
                }}
              />
              <Box style={{marginTop:"30px"}}>
                <UsersResult icebreaker={group?.icebreaker} plan={JSON.parse(group?.plan).plan} group={group} />
              </Box>
            </>
          )}


        </Box>
      </Box>
    </>
  )
};

export default Group;
